import { useQuery } from "@tanstack/react-query";
import { Button, Flex, Typography } from "antd";
import { ActsList } from "entities/acts";
import { getRequests } from "entities/requests";
import { getProfile } from "entities/viewer";
import { CardAttachBlock } from "features/card-bait";
import { ContractsSingWarning } from "features/contracts-sing-warning";
import { ReturnTransactionsBlock } from "features/return-transactions";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import ROUTES from "shared/routes";

export const MainPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { data: requests } = useQuery({
    queryKey: ["requests"],
    queryFn: () => getRequests({ filter: "in_progress" }),
  });

  const { data: profile } = useQuery({
    queryKey: ["profile"],
    queryFn: () => getProfile(),
  });

  return (
    <Flex vertical gap="middle">
      {!!profile?.need_identity_verification && (
        <Button
          type="primary"
          onClick={() => navigate(ROUTES.IDENTITY_VERIFICATION_MAIN)}
          block
        >
          {t("identity_verification.verify_button")}
        </Button>
      )}

      <CardAttachBlock />
      <ReturnTransactionsBlock />
      <ContractsSingWarning />

      <Button onClick={() => navigate(ROUTES.CONTRACTS)} type="primary" block>
        {t("contracts.title")}
      </Button>

      {requests?.data.length ? (
        <Button onClick={() => navigate(ROUTES.REQUESTS)} type="primary" block>
          {t("requests.list_button")}
        </Button>
      ) : null}

      <Typography.Title level={1} style={{ fontSize: 16 }}>
        {t("acts.recent_acts")}
      </Typography.Title>

      <ActsList />
    </Flex>
  );
};
